import React, { MouseEventHandler } from 'react';
import type { StyleProps } from '../../utilities/types';
import footerStyles from './footer.styles';

type StateProps = {
  affinityCompanyCode?: string;
};

export type FooterLinkProps = {
  to?: string;
  ['data-test']: string;
  ['data-track-title']: string;
  title: string;
  href?: string;
  onClick?: MouseEventHandler;
  rel?: string;
  role?: string;
  fill?: boolean;
  isLight?: boolean;
} & StyleProps &
  StateProps;

const FooterLink = ({
  to,
  children,
  affinityCompanyCode,
  isLight,
  fill,
  ...rest
}: FooterLinkProps) => {
  const { hash, pathname, origin } = new URL(to);

  const toUrl = `${origin}${pathname}`;
  const footerLinkClassName = isLight
    ? footerStyles.footerLinkLight
    : footerStyles.footerLinkDefault;

  let footerLink = toUrl;
  if (affinityCompanyCode) footerLink += `?UISCode=${affinityCompanyCode}`;
  if (hash) footerLink += hash;

  const toConfig = { href: footerLink, target: '_blank', rel: 'noopener noreferrer' };

  return (
    <li className={footerStyles.footerLinkWrapper}>
      <a className={footerLinkClassName} {...(to ? toConfig : {})} {...rest}>
        {children}
      </a>
    </li>
  );
};

export default FooterLink;
